var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 40,
    viewBox: "0 0 59 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7496 8.62222C57.7496 8.62222 57.1854 4.71111 55.4479 2.97778C53.259 0.711111 50.7994 0.711111 49.6485 0.577778C41.5927 0 29.475 0 29.475 0H29.4524C29.4524 0 17.3348 0 9.23375 0.577778C8.10548 0.711111 5.64584 0.711111 3.43442 2.97778C1.71944 4.71111 1.15531 8.62222 1.15531 8.62222C1.15531 8.62222 0.568604 13.2444 0.568604 17.8444V22.1556C0.568604 26.7556 1.15531 31.3556 1.15531 31.3556C1.15531 31.3556 1.71944 35.2667 3.45699 37C5.64584 39.2667 8.53422 39.2 9.82046 39.4222C14.4464 39.8667 29.4524 40 29.4524 40C29.4524 40 41.5927 39.9778 49.6711 39.4C50.7994 39.2667 53.259 39.2667 55.4704 37C57.208 35.2667 57.7721 31.3556 57.7721 31.3556C57.7721 31.3556 58.3588 26.7556 58.3588 22.1556V17.8444C58.3363 13.2444 57.7496 8.62222 57.7496 8.62222ZM23.4951 27.3778V11.4L39.1105 19.4222L23.4951 27.3778Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.672f9e34c0c285ccc25762dae83385e7.svg";
export { ForwardRef as ReactComponent };